import React from 'react';
import logomarkOat from '../img/LOGOMARK-OAT.png';

const Navigation = ({ onNavigate, isActive }) => {
  return (
    <section id="navigation" className={`page ${isActive ? 'active' : ''}`}>
      <div className="nav-center">
        <img src={logomarkOat} alt="AIDEA logo" className="nav-logo" />
        <h2 className="brand-name">AIDEA</h2>
      </div>
      <div className="nav-links-wrapper">
        <a 
          className="nav-link" 
          href="#services"
          onClick={(e) => {
            e.preventDefault();
            onNavigate('services');
          }}
        >
          SERVICES
        </a>
        <a 
          className="nav-link" 
          href="#about"
          onClick={(e) => {
            e.preventDefault();
            onNavigate('about');
          }}
        >
          AGENCY
        </a>
        <a 
          className="nav-link" 
          href="#connect"
          onClick={(e) => {
            e.preventDefault();
            onNavigate('connect');
          }}
        >
          CONNECT
        </a>
      </div>
    </section>
  );
};

export default Navigation;
